import { render, staticRenderFns } from "./NewsCategoryIndex.vue?vue&type=template&id=87fa4b6a&lang=pug"
import script from "./NewsCategoryIndex.vue?vue&type=script&lang=js"
export * from "./NewsCategoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports